"use client";

import { Workflow } from "lucide-react";

import { CcCampaignAutomationDemo } from "./CcCampaignAutomationDemo";
import { GrowthFeatureCard } from "./GrowthFeatureCard";
import {
  DEFAULT_GROWTH_FEATURE_CAMPAIGN_COPY,
  type GrowthFeatureCampaignCardCopy,
} from "./growth-feature-campaign-copy";

type GrowthFeatureCampaignAutomationProps = {
  copy?: GrowthFeatureCampaignCardCopy;
};

export function GrowthFeatureCampaignAutomation({
  copy = DEFAULT_GROWTH_FEATURE_CAMPAIGN_COPY,
}: GrowthFeatureCampaignAutomationProps = {}) {
  return (
    <GrowthFeatureCard
      title={copy.title}
      badge={copy.badge}
      icon={Workflow}
      description={copy.description}
    >
      <CcCampaignAutomationDemo copy={copy.demo} />
    </GrowthFeatureCard>
  );
}
